import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import CommonTable from '../../../components/reusable-ui-components/commonTable/CommonTable';
import { getTotalSeatCount } from '../../../utils/getTotalSeatCount';

const DashboardTableOthers = ({ tableData, selectedOrg, type }) => {
    const [rowClickId, setRowClickId] = useState(0);
    const { mode } = useParams();
    const serviceType = mode || type;
    const columnsAct = [
        {
            label: 'Activity Name',
            accessor: 'activityName',
            render: (val) => val || 'N/A'
        },
        {
            label: 'Date',
            accessor: 'date',
            render: (val) => (val ? new Date(val).toLocaleDateString('en-IN') : 'N/A')
        },
        {
            label: 'Activity Place',
            accessor: 'baseCities',
            render: (val) => val || 'N/A'
        },
        {
            label: 'Time Slot',
            accessor: 'startTime',
            render: (val, row) => {
                if (!val || !row.endTime) return '-';

                return `${val} - ${row.endTime}`;
            }
        },
        {
            label: 'Booked Seats',
            accessor: 'bookedSlots',
            render: (val, row) => (
                <div>
                    <strong>{val || 0}</strong> / {row.totalSlots || 0}
                </div>
            )
        },
        {
            label: 'Available Seats',
            accessor: 'availableSlots',
            render: (val) => val ?? 0
        },
        {
            label: 'Difficulty',
            accessor: 'difficulty',
            render: (val) => val || 'N/A'
        }
    ];
    const columnsGu = [
        {
            label: 'Guide Name',
            accessor: 'guideName',
            render: (val) => val || 'N/A'
        },
        {
            label: 'Date',
            accessor: 'date',
            render: (val) => (val ? new Date(val).toLocaleDateString('en-IN') : 'N/A')
        },
        {
            label: ' Place',
            accessor: 'baseCities',
            render: (val) => val || 'N/A'
        },
        {
            label: 'Time Slot',
            accessor: 'startTime',
            render: (val, row) => {
                if (!val || !row.endTime) return '-';

                return `${val} - ${row.endTime}`;
            }
        },
        {
            label: 'Booked Seats',
            accessor: 'bookedSlots',
            render: (val, row) => (
                <div>
                    <strong>{val || 0}</strong> / {row.totalSlots || 0}
                </div>
            )
        },
        {
            label: 'Available Seats',
            accessor: 'availableSlots',
            render: (val) => val ?? 0
        },
        {
            label: 'Difficulty',
            accessor: 'difficulty',
            render: (val) => val || 'N/A'
        }
    ];

    // camp / stay: one row per check-in (rows come from GET /org/dashboard/camp/:orgId)
    const day = (val) => (val ? new Date(val).toLocaleDateString('en-IN') : 'N/A');
    const columnsCamp = [
        {
            label: 'Stay',
            accessor: 'listingName',
            render: (val, row) => (
                <div>
                    <strong>{val || 'N/A'}</strong>
                    {row.place && <div style={{ fontSize: 12, color: '#6b7280' }}>{row.place}</div>}
                </div>
            )
        },
        {
            label: 'Guest',
            accessor: 'guestName',
            render: (val, row) => (
                <div>
                    {val || 'N/A'}
                    {row.phoneNumber && <div style={{ fontSize: 12, color: '#6b7280' }}>{row.phoneNumber}</div>}
                </div>
            )
        },
        { label: 'Check-in', accessor: 'checkIn', render: day },
        { label: 'Check-out', accessor: 'checkOut', render: (val, row) => `${day(val)} (${row.nights || 0}N)` },
        { label: 'Rooms', accessor: 'rooms', render: (val) => val || '-' },
        {
            label: 'Guests',
            accessor: 'adults',
            render: (val, row) =>
                [`${val || 0} adult${val === 1 ? '' : 's'}`, row.children ? `${row.children} child` : '', row.pets ? `${row.pets} pet` : '']
                    .filter(Boolean)
                    .join(', ')
        },
        {
            label: 'Paid',
            accessor: 'paid',
            render: (val, row) => (
                <div>
                    ₹{val || 0}
                    {row.isReserved && <div style={{ fontSize: 12, color: 'red' }}>of ₹{row.total} (reserved)</div>}
                </div>
            )
        },
        { label: 'Via', accessor: 'bookedVia', render: (val) => val || '-' },
        {
            label: 'Status',
            accessor: 'status',
            render: (val) => <span style={val === 'Cancelled' ? { color: 'red', fontWeight: 600 } : undefined}>{val}</span>
        }
    ];

    if (serviceType === 'c') {
        return (
            <div className='dashboard'>
                <CommonTable data={tableData} columns={columnsCamp} setRowClickId={() => {}} />
            </div>
        );
    }

    if (rowClickId !== 0) {
        const dateId = serviceType === 'a' ? rowClickId?.actDatesId : rowClickId?.guDatesId;
        const slotId = rowClickId?.slotId;
        window.open(`/support/${serviceType}/date/${selectedOrg}/${dateId}/${slotId}`);
        setRowClickId(0);
    }

    return (
        <div className='dashboard'>
            <CommonTable
                data={tableData}
                columns={serviceType === 'a' ? columnsAct : columnsGu}
                setRowClickId={setRowClickId}
            />
        </div>
    );
};

export default DashboardTableOthers;
